// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "23578114ba474dd92da5bef4bc2fe0f1" + ".js";
};